import { get, noop } from 'lodash';
export const timeoutPromise = (promise, ms, errMsg, abortSignal = {}) => {
    const abort = get(promise, 'abort', noop);
    promise = get(promise, 'ready', promise);
    if (abortSignal.aborted) {
        abort();
    }
    else if (abortSignal.addEventListener) {
        abortSignal.addEventListener('abort', () => {
            abort();
        });
    }
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            abort();
            const error = new Error(errMsg);
            error.name = 'TimeoutError';
            reject(error);
        }, ms);
        promise.then(resolve, reject);
    });
};
//# sourceMappingURL=timeout-promise.js.map